module.exports = __webpack_public_path__ + "static/media/bishop-fenwick.39bc5666.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/bishop-fenwick.jpg
// module id = 614
// module chunks = 0